import fetchBatchListings from '../request/fetchBatchListings'
import useOnInit from './useOnInit'

const useListingsOnComposeInit = (props, params, isEditPage, beforeInit, afterInit) => {
  const {
    actions
  } = props

  const getBatchListings = async () => {
    beforeInit && beforeInit()
    const [error, batchListings = []] = await fetchBatchListings(actions, params)
    if (error) {
      afterInit(error)
      return
    }

    afterInit(null, batchListings)
  }

  useOnInit(() => {
    isEditPage && getBatchListings()
  })
}

export default useListingsOnComposeInit
